"use client";
import { pathTranslator } from "../../../utils/language";
import { List } from "../../Listbox/Listbox";
import styles from "./LanguageToggle.module.scss";
import { useGlobalContext } from "@aleksundshantu/aunds-utils-react/contexts";
import { Post } from "@aleksundshantu/aunds-deepl-unmute-types/client";

const SELECTED_ICON_KEY = "check-mark";

// Native language name, e.g. "en" → "English", "ja" → "日本語"
const getLanguageName = (languageCode: string) => {
  try {
    return (
      new Intl.DisplayNames([languageCode], { type: "language" }).of(
        languageCode,
      ) ?? languageCode
    );
  } catch {
    return languageCode;
  }
};

export const LanguageToggle = ({
  post,
  addWrapper = false,
}: {
  post: Post;
  addWrapper?: boolean;
}) => {
  const { locale } = useGlobalContext();
  const availableTranslations = pathTranslator(post);
  const onLanguagePick = (e: string) => {
    if (availableTranslations.length > 0) {
      document.cookie = `NEXT_LOCALE=${e}; path=/`;
      document.documentElement.lang = e;
    }
  };

  const ListJSX = (
    <List
      selected={locale}
      availableTranslations={availableTranslations}
      setSelected={onLanguagePick}
      items={
        process.env.NEXT_PUBLIC_LOCALES?.split(",")
          .filter(
            (l) =>
              l === locale || availableTranslations.some((a) => a.lang === l),
          )
          .map((l) => ({ label: getLanguageName(l), value: l })) ?? []
      }
      disableDropdown={availableTranslations.length < 1}
      closeOnSelection
      openOnHover
      selectedIconKey={SELECTED_ICON_KEY}
    />
  );

  return addWrapper ? (
    <div className={`language-wrapper ${styles["language-wrapper"]}`}>
      {ListJSX}
    </div>
  ) : (
    ListJSX
  );
};
